import { render, staticRenderFns } from "./catalogue-session-list.vue?vue&type=template&id=682cbd88&scoped=true&"
import script from "./catalogue-session-list.vue?vue&type=script&lang=js&"
export * from "./catalogue-session-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682cbd88",
  null
  
)

export default component.exports